import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeProvider/ThemeProvider';
import { TestBar } from './components/layout-components/TestBar';
import { ErrorBoundary } from 'react-error-boundary';
import FallbackComponent from 'components/fallback-component/FallbackComponent';

const queryClient = new QueryClient();

function App() {
  return (
    <ErrorBoundary fallbackRender={FallbackComponent}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TestBar />
          <Router>
            <Routes>
              <Route path="/*" element={<Views />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
